import React, { createContext, useMemo, useState } from 'react';

type ScaleContextType = {
  scale: number;
  setScale: (value: number) => void;
};

export const ScaleContext = createContext<ScaleContextType>({
  scale: 1,
  setScale: () => {}
});

export const ScaleContextProvider = ({ children }: any) => {
  const [scale, setScale] = useState<number>(1);

  // PERF: memoized so consumers only re-render when one of these values
  // actually changes, not on every provider re-render. See
  // docs/investigations/20260819-game-client-overheating.md.
  const value = useMemo(() => ({ scale, setScale }), [scale]);
  return <ScaleContext.Provider value={value}>{children}</ScaleContext.Provider>;
};

export default ScaleContext;
